import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import { TENANT_ID } from '@angular/fire/compat/auth';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { acceptLanguageInterceptor } from '@suvo/frontend-framework/standalone/i18n';
import { provideSandboxedWebComponentIframeSrc } from '@suvo/frontend-framework/standalone/web-components/sandboxed/sandboxed-web-component-iframe-src.provider';
import { CustomComponentRPCModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/custom-components/rpc/custom-component-rpc.module';
import { DashboardsModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/dashboards.module';
import { SelectedTenantInterceptor } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/authentication/interceptors/selected-tenant/selected-tenant.interceptor';
import { NgxStripeModule, StripeService } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrivateModule } from './private/private.module';
import { PublicModule } from './public/public.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    PublicModule,
    PrivateModule,
    AngularFireModule,
    NgxStripeModule.forRoot(''),
    DashboardsModule.forRoot(environment),
    CustomComponentRPCModule,
    MonacoEditorModule.forRoot(), // TODO: Review the import point. @victor-shelepen
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [StripeService],
      useFactory: (stripeService: StripeService) => () => {
        stripeService.changeKey(environment.stripePublicKey);
      },
    },
    {
      provide: TENANT_ID,
      useFactory() {
        return environment.platformFirebaseTenantID;
      },
    },
    {
      provide: FIREBASE_OPTIONS,
      useValue: {
        authDomain: environment.firebaseAuthDomain,
        apiKey: environment.firebaseApiKey,
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SelectedTenantInterceptor,
      multi: true,
    },
    provideSandboxedWebComponentIframeSrc('/assets/sandboxed-web-component-iframe.html'),
    provideTranslateService({ defaultLanguage: 'en' }),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([acceptLanguageInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
